import { CssBaseline, ThemeProvider } from '@mui/material';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { useCookieConsent } from '../main-app/modules/cookie-consent/useCookieConsent';
import { SentryFallbackRender } from '../main-app/pages/error/SentryFallback';
import { theme } from '../main-app/style/theme';
import { NotificationsProvider } from '../main-app/utils/notification';
import { InvoiceAppRouter } from './router';

const queryClient = new QueryClient();

function InvoiceApp() {
  useCookieConsent();

  return (
    <Sentry.ErrorBoundary fallback={SentryFallbackRender}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <NotificationsProvider />
          <BrowserRouter>
            <InvoiceAppRouter />
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}

export default InvoiceApp;
